(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-pdp-accordions] .pdp-acc__head').forEach(function (head) {
      head.addEventListener('click', function () {
        var acc = head.closest('.pdp-acc');
        var open = acc.classList.toggle('open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  })();

  // Move PDF manual links (e.g. User Guide, Safety Instructions) out of the description and into
  // the Manuals dropdown. If nothing is found, remove the now-empty Manuals accordion.
  (function () {
    var ul = document.querySelector('[data-pdp-manuals]');
    if (!ul) return;
    var descBody = document.querySelector('[data-pdp-accordions] .description-panel');
    if (descBody) {
      var icon = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/><path d="M12 12v5M9.5 14.5 12 17l2.5-2.5"/></svg>';
      Array.prototype.slice.call(descBody.querySelectorAll('a')).forEach(function (a) {
        if ((a.getAttribute('href') || '').toLowerCase().indexOf('.pdf') === -1) return;
        var name = (a.textContent || '').replace(/\s+/g, ' ').trim() || 'Download';
        var li = document.createElement('li');
        li.innerHTML = '<a href="' + a.href + '" target="_blank" rel="noopener" download>' + icon + '<span>' + name + '</span></a>';
        ul.appendChild(li);
        var p = a.closest('p');
        if (p && p.textContent.replace(/\s+/g, ' ').trim() === name) { p.remove(); } else { a.remove(); }
      });
    }
    if (!ul.children.length) { var acc = ul.closest('.pdp-acc'); if (acc) { acc.remove(); } }
  })();

  // Tabs layout: builds a tab bar from the accordion items and shows one panel at a time.
  // Runs after the Manuals clean-up above so removed panels never get a tab. The active
  // panel is the item with the "open" class, so anything that opens an item (e.g. the
  // star-rating link opening Reviews) also switches the tab.
  (function () {
    document.querySelectorAll('[data-pdp-accordions]').forEach(function (root) {
      var layout = root.dataset.pdpLayout || 'tabs';
      if (layout === 'accordion') return;

      var desktop = window.matchMedia('(min-width: 768px)');
      var items = Array.prototype.filter.call(root.children, function (el) {
        return el.classList.contains('pdp-acc');
      });
      if (!items.length) return;

      var nav = document.createElement('div');
      nav.className = 'pdp-tabs__nav';
      nav.setAttribute('role', 'tablist');
      root.insertBefore(nav, root.firstChild);

      var tabs = items.map(function (acc, i) {
        var title = acc.querySelector('.pdp-acc__title');
        var panel = acc.querySelector('.pdp-acc__panel');
        if (!panel.id) panel.id = root.id + '-panel-' + (i + 1);

        var tab = document.createElement('button');
        tab.type = 'button';
        tab.className = 'pdp-tabs__tab';
        tab.id = panel.id + '-tab';
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panel.id);
        tab.textContent = title ? title.textContent.trim() : 'Tab ' + (i + 1);
        tab.addEventListener('click', function () { activate(acc); });
        nav.appendChild(tab);
        return tab;
      });

      var current = null;

      function isTabs() {
        return layout === 'tabs' || desktop.matches;
      }

      function activate(acc, focusTab) {
        current = acc;
        items.forEach(function (item, i) {
          var active = item === acc;
          item.classList.toggle('open', active);
          var head = item.querySelector('.pdp-acc__head');
          if (head) head.setAttribute('aria-expanded', active ? 'true' : 'false');
          tabs[i].setAttribute('aria-selected', active ? 'true' : 'false');
          tabs[i].tabIndex = active ? 0 : -1;
          if (active && focusTab) tabs[i].focus();
        });
      }

      function apply() {
        var useTabs = isTabs();
        root.classList.toggle('is-tabs', useTabs);
        items.forEach(function (item, i) {
          var panel = item.querySelector('.pdp-acc__panel');
          if (useTabs) {
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('aria-labelledby', tabs[i].id);
          } else {
            panel.removeAttribute('role');
            panel.removeAttribute('aria-labelledby');
          }
        });
        if (useTabs) {
          var opened = items.filter(function (item) { return item.classList.contains('open'); })[0];
          activate(current && current.isConnected ? current : opened || items[0]);
        }
      }

      nav.addEventListener('keydown', function (e) {
        var index = tabs.indexOf(document.activeElement);
        if (index === -1) return;
        var next = null;
        if (e.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (e.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        e.preventDefault();
        activate(items[next], true);
      });

      // Keep exactly one panel open in tabs mode when something else toggles "open"
      var observer = new MutationObserver(function () {
        if (!isTabs()) return;
        var opened = items.filter(function (item) { return item.classList.contains('open') && item !== current; })[0];
        if (opened) activate(opened);
        else if (current && !current.classList.contains('open')) activate(current);
      });
      items.forEach(function (item) { observer.observe(item, { attributes: true, attributeFilter: ['class'] }); });

      desktop.addEventListener('change', apply);
      apply();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
